<tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf">
    <student-header [showYearSelector]="false"
        [pageTitle]="SDMIntegration ? 'Student Document Management' : 'Individualized Education Program'"
        class="flex-header"
        #studentHeader></student-header>
    <div class="flex-content">
        <div style="text-align:center;" *ngIf="iepData.length == 0 && isBusy==false">
            <span translate>No IEP data exists for student.</span>
        </div>
        <div *ngIf="iepData.length > 0">
            <mat-table #table [dataSource]="angularMatData" multiTemplateDataRows matSort matSortDisableClear
                id="spedCollectionDataTable" aria-label="Sped Collection Data Table" tabindex="0">
                <ng-container matColumnDef="CollectionName">
                    <mat-cell *matCellDef="let collection" style="text-align:left;">
                        <b style="font-size: 12pt;color: #3f51b5;">
                            {{collection.CollectionName | translate}}
                        </b>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Expand">
                    <mat-cell *matCellDef="let collection let i = index" style="max-width:40px;">
						<span *ngIf="collection.Documents.length > 0" aria-label="Expand row for more details">
							<i [ngClass]="checkExpanded(collection) ? 'detail-row-collapsed-icon' : 'detail-row-expanded-icon'"
                                aria-hidden="true"></i>
						</span>
                    </mat-cell>
                </ng-container>
                <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let collectionRow"
                        [attr.colspan]="columnsToDisplayCount(collectionRow.Fields)" style="width:100%;">
                        <mat-table [dataSource]="collectionRow.Documents" style="width: 100%"
                            aria-label="IEP Details Table"
                            tabindex="0">
                            <ng-container matColumnDef="View">
                                <mat-header-cell *matHeaderCellDef style="max-width:80px;"></mat-header-cell>
                                <mat-cell *matCellDef="let detail" style="max-width:80px;">
                                    <a (click)="viewDocumentClick(detail, collectionRow.CollectionName)"
                                        style="cursor: pointer;"><span translate>View</span></a>
                                </mat-cell>
                            </ng-container>
                            <ng-container *ngFor="let field of collectionRow.Fields" [matColumnDef]="field">
                                <mat-header-cell *matHeaderCellDef
                                    style="padding-left:10px;">{{field | translate}}</mat-header-cell>
                                <mat-cell *matCellDef="let detail" style="padding-left:10px;">
                                    <tyl-quill-text-only *ngIf="V10"
                                        [padding]="0"
                                        [html]="to_trustedHtml(detail.FieldValue[field])"></tyl-quill-text-only>
                                    <span *ngIf="!V10">{{detail.FieldValue[field]}}</span>
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="Attachment">
                                <mat-header-cell *matHeaderCellDef style="max-width:15px;">
                                    <img src="./assets/images/paperclip.png" style="height:20px;"/>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let detail" style="max-width:15px;">
                                    <a (click)="viewDocumentAttachmentDialog(detail)"
                                        style="cursor: pointer;">{{detail.Attachment}}</a>
                                </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="getColumnsToDisplay(collectionRow)"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: getColumnsToDisplay(collectionRow);"
                                style="overflow: hidden;" tabindex="0"
                                [attr.aria-label]="getAriaDetailRow(collectionRow.Fields,row)">
                            </mat-row>
                        </mat-table>
                    </td>
                </ng-container>
                <mat-row *matRowDef="let row; columns: columnsToDisplay;" tabindex="0"
                    [attr.aria-label]="getAriaRow(row)"
                    [ngStyle]="{'background-color':'#e8eaf6'}" style="padding:0px;overflow: hidden;" matRipple
                    (click)="toggleExpanded(row)"></mat-row>
                <mat-row class="mat-detail-row" *matRowDef="let row; columns: ['expandedDetail']"
                    [@detailExpand]="checkExpanded(row) && row.Documents.length > 0 ? 'expanded' : 'collapsed'"
                    style="overflow: hidden"></mat-row>
            </mat-table>
        </div>
    </div>
</tyl-kendo-pdf-export>
<div #footer class="flex-footer">
    <div class="flex-footer-left">
        <tyl-button image="Expand All.png" label="Expand All" (clickEvent)="expandAll(true)"></tyl-button>
        <tyl-button image="Collapse All.png" label="Collapse All" (clickEvent)="expandAll(false)"></tyl-button>
    </div>
</div>
